<template>
  <bg-modal
    :value="value"
    title="Ubah Notifikasi"
    desktop-size="md"
    :body-scroll="false"
    button-main-text="Simpan"
    button-second-text="Batal"
    :button-main-props="{ loading: saving }"
    class="notification-setting-edit-modal"
    @input="$emit('input', $event)"
    @click-main-action="handleSave"
    @click-second-action="handleCancel"
  >
    <div class="notification-setting-edit-modal__recipient">
      <bg-text size="body-2">
        <strong>{{ recipient.name || '-' }}</strong>
        ({{ roleLabel }}) &middot; {{ recipient.phone_number || '-' }}
      </bg-text>

      <bg-text
        v-if="recipient.note"
        size="body-4"
        class="notification-setting-edit-modal__note"
      >
        Catatan: {{ recipient.note }}
      </bg-text>
    </div>

    <bg-text size="title-4">Notifikasi</bg-text>

    <bg-text size="body-2" class="notification-setting-edit-modal__desc">
      Jika diaktifkan, nomor ini akan menerima notifikasi melalui WhatsApp.
    </bg-text>

    <div class="notification-setting-edit-modal__toggles">
      <div
        v-for="type in types"
        :key="type.value"
        class="notification-setting-edit-modal__toggle-row"
      >
        <bg-text size="body-2">{{ labelFor(type) }}</bg-text>

        <bg-switch
          v-model="localEnabled[type.value]"
          :data-testid="`notificationSetting-${type.value}-switch`"
        />
      </div>
    </div>
  </bg-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api';
import { BgModal, BgText, BgSwitch } from 'bangul-vue';
import {
  keeperRoleLabel,
  notificationTypeLabel,
} from '@admin/pages/PropertyNotificationSettings/constants';

export default {
  name: 'NotificationSettingEditModal',

  components: {
    BgModal,
    BgText,
    BgSwitch,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    recipient: {
      type: Object,
      default: () => ({}),
    },
    types: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const localEnabled = ref({});

    const roleLabel = computed(() => keeperRoleLabel(props.recipient.role));

    const labelFor = type => notificationTypeLabel(type.value, type.label);

    const syncLocalEnabled = () => {
      const enabled = props.recipient.enabled_notification_types || [];

      localEnabled.value = props.types.reduce((acc, type) => {
        acc[type.value] = enabled.includes(type.value);
        return acc;
      }, {});
    };

    // Re-seed the toggles whenever the modal opens for a (new) recipient.
    watch(
      () => props.value,
      isOpen => {
        if (isOpen) syncLocalEnabled();
      },
      { immediate: true }
    );

    const handleCancel = () => emit('input', false);

    const handleSave = () => {
      const enabledTypes = props.types
        .map(type => type.value)
        .filter(value => localEnabled.value[value]);
      emit('save', { recipient: props.recipient, enabledTypes });
    };

    return { localEnabled, roleLabel, labelFor, handleCancel, handleSave };
  },
};
</script>

<style lang="scss" scoped src="./NotificationSettingEditModal.scss" />
